import { render, staticRenderFns } from "./AdminSharedPlaceImages.vue?vue&type=template&id=6fb715b7&scoped=true"
import script from "./AdminSharedPlaceImages.vue?vue&type=script&lang=js"
export * from "./AdminSharedPlaceImages.vue?vue&type=script&lang=js"
import style0 from "./AdminSharedPlaceImages.vue?vue&type=style&index=0&id=6fb715b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb715b7",
  null
  
)

export default component.exports